import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule, RouteGuard } from './app-routing.module';
import { AppComponent } from './app.component';
import { ObservationBoxComponent } from './components/shared/observation-box/observation-box.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { UserDataInputComponent } from './components/shared/user-data-input/user-data-input.component';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomButtonComponent } from './components/shared/custom-button/custom-button.component';
import { SmileyComponent } from './components/shared/smiley/smiley.component';
import { QuestionComponent } from './components/shared/question/question.component';
import { CategoryTitleComponent } from './components/shared/category-title/category-title.component';
import { ProgressBarComponent } from './components/shared/progress-bar/progress-bar.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { UserDataComponent } from './components/user-data/user-data.component';
import { FinalizationComponent } from './components/finalization/finalization.component';
import { CompletedComponent } from './components/completed/completed.component';
import { PollComponent } from './components/poll/poll.component';
import { PollManagerComponent } from './components/poll-manager/poll-manager.component';
import { InvalidControlScrollDirective } from './directives/invalid-control-scroll.directive';
import { HttpClientModule } from '@angular/common/http';
import { ApiModule } from './services/client/api.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingComponent } from './components/shared/loading/loading.component';
import { CustomErrorComponent } from './components/shared/custom-error/custom-error.component';
import { APP_BASE_HREF, LocationStrategy } from '@angular/common';
import { CustomHashLocationStrategy } from './custom-hash-location-strategy';
import { StarsComponent } from './components/shared/stars/stars.component';

@NgModule({
  declarations: [
    AppComponent,
    ObservationBoxComponent,
    UserDataInputComponent,
    CustomButtonComponent,
    SmileyComponent,
    QuestionComponent,
    CategoryTitleComponent,
    ProgressBarComponent,
    FooterComponent,
    HeaderComponent,
    IntroductionComponent,
    UserDataComponent,
    FinalizationComponent,
    CompletedComponent,
    PollComponent,
    PollManagerComponent,
    InvalidControlScrollDirective,
    LoadingComponent,
    CustomErrorComponent,
    StarsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NoopAnimationsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    ApiModule,
  ],
  providers: [
    RouteGuard,
    {provide: APP_BASE_HREF, useValue: window['base-href']},
    {provide: LocationStrategy, useClass: CustomHashLocationStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
